import React from 'react';
import PropTypes from 'prop-types';

export default class FormInputText extends React.Component {
  constructor(props) {
    super(props);

    this.onInput = this.onInput.bind(this);
  }

  onInput = (event) => {
    const { fieldData, userInputHandler } = this.props;

    userInputHandler(fieldData.name, event.currentTarget.value);
  };

  render() {
    const { fieldData, fieldInput } = this.props;

    return (
      <input
        type={fieldData.field_type}
        placeholder={fieldData.placeholder}
        name={fieldData.name}
        onInput={this.onInput}
        onChange={this.onInput}
        value={fieldInput}
      />
    );
  }
}

FormInputText.propTypes = {
  fieldData: PropTypes.shape({
    field_type: PropTypes.string,
    req: PropTypes.string,
    desc_pos: PropTypes.string,
    name: PropTypes.string,
    desc: PropTypes.string,
    placeholder: PropTypes.string,
    email_conf: PropTypes.string,
    value: PropTypes.string,
    repeat: PropTypes.array,
  }).isRequired,
  fieldInput: PropTypes.string.isRequired,
  userInputHandler: PropTypes.func.isRequired,
};
